import axios from "axios";
import he from "he";

const install = function (Vue) {
  // 1. add global method or property
  Vue.myGlobalMethod = function () {
    // some logic ...
  };

  // 2. add a global asset
  // Vue.directive('my-directive', {
  //   bind (el, binding, vnode, oldVnode) {
  //     // some logic ...
  //   }
  //   ...
  // })
  // By varsan
  const originalConsoleLog = console.log;
  // 3. inject some component options
  Vue.mixin({
    methods: {
      isConsole(isEnable) {
        if (!isEnable) {
          console.log = function () {};
        } else {
          console.log = originalConsoleLog;
        }
      },
      async languageTransfer(data, lang) {
        console.log("languageTransfer::", data, lang);

        try {
          // Ensure that data is a string
          if (typeof data !== "string") {
            console.error("Data must be a string");
            return ""; // Or you could throw an error depending on your use case
          }

          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=${process.env.VUE_APP_TRANSLATES_KEY}`,
            { q: data, target: lang },
            { headers: { "Content-Type": "application/json" } }
          );

          const translations = response.data.data.translations.map(
            (t) => t.translatedText
          );

          return he.decode(translations[0] || "");
        } catch (error) {
          console.error("Translation error:", error);
          return "";
        }
      },

      async languageTransferArray(dataArray, lang) {
        console.log("languageTransfer::", dataArray, lang);

        try {
          // Ensure dataArray is an array
          if (!Array.isArray(dataArray)) {
            console.error("Data must be an array of strings");
            return []; // Or throw an error if required
          }

          // Limit to a maximum of 10 items
          const limitedData = dataArray.slice(0, 12);

          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=${process.env.VUE_APP_TRANSLATES_KEY}`,
            { q: limitedData, target: lang },
            { headers: { "Content-Type": "application/json" } }
          );

          const translations = response.data.data.translations.map((t) =>
            he.decode(t.translatedText || "")
          );

          return translations;
        } catch (error) {
          console.error("Translation error:", error);
          return [];
        }
      },
    },
  });

  // 4. add an instance method
  // Vue.prototype.$myMethod = function (methodOptions) {
  //
  //   // some logic ...
  // }
};

const customPlugin = {
  install,
};
export default customPlugin;
